import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';

import { FaShare, FaAngleUp, FaAngleDown } from 'react-icons/fa';

class RankedBeginView extends React.Component {

	render() {

        const style = {
            opacity: this.props.opacity,
        }

        return (
            <div class="main4" id="main">
                <div class="gameStart" style={style}>

                    <table>
                        <tr>
                            <td class="solidWhiteRed">
                                <div class="name2">
                                    {this.props.name1}<br/>
                                    { this.props.rank1 ? ("rank: " + this.props.rank1) : "" }
                                </div>
                            </td>
                            <td class="solidWhiteRed">
                                <div class="name2">
                                    {this.props.name2}<br/>
                                    { this.props.rank2 ? ("rank: " + this.props.rank2) : "" }
                                </div>
                            </td>
                        </tr>

                    </table>

                </div>

                <div class="hoverMiddleVS" style={style}>
                    VS
                </div>
            </div>
        );   
    }
}

RankedBeginView.propTypes = {
    opacity: PropTypes.number,
    name1: PropTypes.string,
    name2: PropTypes.string,
    rank1: PropTypes.number,
    rank2: PropTypes.number,
};

export default RankedBeginView;